import {QueryClientProvider} from '@tanstack/react-query';
import React, {PropsWithChildren} from 'react';
import {queryClient} from '../api/queryClient';
import {LayoutContextProvider} from './Layout';
import {SelectedAcodesContextProvider} from './SelectedAcodes';
import DimensionsContext from './modules/dimensions/DimensionsContext';
import {AriaLiveContextProvider} from './AriaLive';
import {ScrollContextProvider} from './Scroll';

export default ({children}: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
        <LayoutContextProvider>
          <ScrollContextProvider>
            <AriaLiveContextProvider>
              <SelectedAcodesContextProvider>
                <DimensionsContext>
                    {children}
                </DimensionsContext>
              </SelectedAcodesContextProvider>
            </AriaLiveContextProvider>
          </ScrollContextProvider>
        </LayoutContextProvider>
    </QueryClientProvider>
  );
};
